var exports = {
  "Y2": "FriendListItem.module__friendListItem___NE1QYT",
  "lY": "FriendListItem.module__contextMenuActive___NE1QYT",
  "Hb": "FriendListItem.module__friendInfo___NE1QYT",
  "HX": "FriendListItem.module__friendDetails___NE1QYT",
  "Um": "FriendListItem.module__friendNameRow___NE1QYT",
  "G3": "FriendListItem.module__friendName___NE1QYT",
  "tf": "FriendListItem.module__friendTag___NE1QYT",
  "kC": "FriendListItem.module__friendSubtext___NE1QYT",
  "MI": "FriendListItem.module__friendStatusOffline___NE1QYT",
  "wh": "FriendListItem.module__friendStatusOnline___NE1QYT",
  "yA": "FriendListItem.module__friendActions___NE1QYT",
  "I0": "FriendListItem.module__actionButtonMessage___NE1QYT",
  "cQ": "FriendListItem.module__actionButtonMore___NE1QYT",
  "nl": "FriendListItem.module__contextMenuButtonActive___NE1QYT",
  "TI": "FriendListItem.module__actionButtonAccept___NE1QYT",
  "Tl": "FriendListItem.module__actionButtonIgnore___NE1QYT",
  "P7": "FriendListItem.module__actionButtonCancel___NE1QYT",
  "RK": "FriendListItem.module__iconSize___NE1QYT",
};

module.exports = exports;
